var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer__wrapper text-light-gray"},[_c('footer-content'),_vm._v(" "),_c('footer-terms')],1)}
var staticRenderFns = []

export { render, staticRenderFns }